export function registerWithGlobalApp(key: string, value: any): void {
  if (window['app'] == null) {
    window['app'] = {};
  }

  window['app'][key] = value;
}
